import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withComponentId } from '../../../common/ComponentIdContext';
import { withComponentName } from '../../../common/ComponentNameContext';
import { TYPE_DISABLE } from '../../../common/sync-component/Const';
import { syncComponentSelector } from '../../../helpers/Common';
import EventEmitter, {
  SYNC_COMPONENT_SEARCH,
} from '../../../helpers/EventEmitter';
import { changeCode } from '../reducer';
import { SearchFilter } from '../../../common/search-filter';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from './../../../app/commonReducer';

const getListSearchFromRedux = state =>
  state[COMMON_REDUCER_NAME].listOrganizationSearch;

class SearchBox extends React.Component {
  componentDidMount() {
    EventEmitter.subscribe(SYNC_COMPONENT_SEARCH, this.onSyncSearch);
  }

  componentWillUnmount() {
    EventEmitter.unsubscribe(SYNC_COMPONENT_SEARCH, this.onSyncSearch);
  }

  onSyncSearch = data => {
    const { syncType, changeCode, componentId } = this.props;
    if (
      syncType === TYPE_DISABLE ||
      data.syncType !== syncType ||
      data.search.isIndex ||
      data.search.isDerivatives ||
      !data.search.isTicker ||
      componentId === data.componentId
    ) {
      return;
    }
    changeCode(data.search, componentId);
  };

  clickItemSearch = currentSearch => {
    const { id, changeCode, syncType, componentId } = this.props;

    changeCode(currentSearch, id);
    if (syncType === TYPE_DISABLE) {
      return;
    }
    EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
      syncType: syncType,
      search: currentSearch,
      componentId,
    });
  };

  render() {
    const { currentSearch } = this.props;

    return (
      <SearchFilter
        schema={[
          { key: 'displayCode', className: 'w-20' },
          { key: 'codeName', className: 'w-55 text-truncate' },
          {
            key: 'exchange',
            className: 'w-25 text-right',
            render: text => {
              return text.toUpperCase();
            },
          },
        ]}
        listKeyFilter={['displayCode', 'codeName']}
        getListSearchFromRedux={getListSearchFromRedux}
        currentSearch={currentSearch}
        sortKey={'displayCode'}
        mainKey={'code'}
        clickItemSearch={this.clickItemSearch}
        customWidth={170}
      />
    );
  }
}

const mapStateToProps = (state, { componentName, componentId }) => ({
  syncType: syncComponentSelector(state, componentName, componentId),
});

const mapDispatchToProps = {
  changeCode,
};

export default compose(
  withComponentId,
  withComponentName,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(SearchBox);
